if (!customElements.get('product-listing')) {
  class ProductListing extends HTMLElement {
    constructor() {
      super();
      this.page = 1;
      this.sortBy = 'relevency';
      this.narrowBy = [];
      this.query = '';
      this._restored = false;
      this.sortMap = {};
      this.genderFacetKey = 'Isp-tag-Gender';
      this.productsPerPage = this.dataset.productsPerPage || 48;
    }

    connectedCallback() {
      const searchParams = new URLSearchParams(window.location.search);

      this.query = searchParams.get('q') || '';
      this.sortBy = searchParams.get('sortBy') || 'relevency';

      this.sortMap = {
        [`${this.dataset.prefix}products`]: 'relevency',
        [`${this.dataset.prefix}products_best_selling`]: 'popularity',
        [`${this.dataset.prefix}products_price_descending`]: 'price_max_to_min',
        [`${this.dataset.prefix}products_price_ascending`]: 'price_min_to_max'
      };

      this.syncSortDropdown();
      this.addDelegatedEventListeners();
      this.waitForFastSimon();
    }

    waitForFastSimon() {
      const interval = setInterval(() => {
        if (window.FastSimonSDK) {
          clearInterval(interval);
          this.syncFromUrl();
          this.loadPage();
        }
      }, 50);
    }

    setGender(value, { skipUrlUpdate = false } = {}) {
      const facetKey = this.genderFacetKey;
      const nextValue = value || '';

      const genderRadios = this.querySelectorAll(`input[type="radio"][name="${facetKey}"]`);
      genderRadios.forEach(radio => {
        radio.checked = radio.value === nextValue;
      });

      const genderCheckboxes = this.querySelectorAll(`input[type="checkbox"][name="${facetKey}"]`);
      genderCheckboxes.forEach(checkbox => {
        checkbox.checked = nextValue ? checkbox.value === nextValue : false;
      });

      if (!skipUrlUpdate) {
        const searchParams = new URLSearchParams(window.location.search);
        if (nextValue) searchParams.set(facetKey, nextValue);
        else searchParams.delete(facetKey);
        history.replaceState({}, '', `?${searchParams}`);
      }
    }

    syncGenderFromInput(inputElement) {
      if (!inputElement || inputElement.name !== this.genderFacetKey) return;

      if (inputElement.type === 'radio') {
        this.setGender(inputElement.value, { skipUrlUpdate: true });
        return;
      }

      if (inputElement.type === 'checkbox') {
        if (inputElement.checked) {
          this.querySelectorAll(`input[type="checkbox"][name="${this.genderFacetKey}"]`).forEach(cb => {
            cb.checked = cb === inputElement;
          });
          this.setGender(inputElement.value, { skipUrlUpdate: true });
        } else {
          const remainingChecked = this.querySelector(
            `input[type="checkbox"][name="${this.genderFacetKey}"]:checked`
          )?.value;

          this.setGender(remainingChecked || '', { skipUrlUpdate: true });
        }
      }
    }

    syncSortDropdown() {
      const defaultIndex = `${this.dataset.prefix}products`;
      const matchedIndex = Object.keys(this.sortMap).find(
        indexKey => this.sortMap[indexKey] === this.sortBy
      );
      const valueToSet = matchedIndex || defaultIndex;
      const sortDropdowns = this.querySelectorAll('[data-action="fs-sort"]');

      sortDropdowns.forEach(select => {
        if (select.value !== valueToSet) {
          select.value = valueToSet;
        }
      });
    }

    trackProductClick(anchor, index) {
      const eventData = {
        kl_id: this.klaviyoID,
        productID: anchor.dataset.productId,
        position: index + 1
      };

      if (this.dataset.id === 'search') {
        const searchParams = new URLSearchParams(window.location.search);
        const term = searchParams.get('q');
        eventData.query = term;

        window.FastSimonSDK.event({
          eventName: window.FastSimonEventName.SerpProductClicked,
          data: eventData
        });
      } else {
        eventData.collectionID = this.dataset.collectionId || this.dataset.id;
        eventData.query = undefined; // Default = Collection_Name

        window.FastSimonSDK.event({
          eventName: window.FastSimonEventName.CollectionProductClicked,
          data: eventData
        });
      }
    }

    addDelegatedEventListeners() {
      ['click', 'change'].forEach(eventType => {
        this.addEventListener(eventType, event => {
          const actionElement = event.target.closest('[data-action]');
          if (!actionElement) return;

          if (eventType === 'click' && actionElement.dataset.action === 'fs-sort') return;

          const searchParams = new URLSearchParams(window.location.search);

          switch (actionElement.dataset.action) {
            case 'fs-filter-change': {
              const clickedElement = actionElement;

              const quickLinkFilter =
                clickedElement.dataset.quickLinkFilter ||
                clickedElement.closest('[data-quick-link-filter]')?.dataset.quickLinkFilter ||
                null;

              if (quickLinkFilter) {
                const [rawName, ...rest] = String(quickLinkFilter).split(':');
                const filterName = (rawName || '').trim().toLowerCase();
                const filterValue = rest.join(':').trim();

                this.querySelectorAll('[data-quick-link-filter]').forEach(tile => {
                  const isActive = (tile.dataset.quickLinkFilter || '') === String(quickLinkFilter);
                  tile.classList.toggle('border-black', isActive);
                  tile.classList.toggle('active', isActive);
                  tile.classList.toggle('border-ashGray', !isActive);
                  if (!isActive) tile.classList.remove('active');
                });

                const group = this.querySelector(`ul[data-filter-name="${CSS.escape(filterName)}"]`);

                if (group) {
                  const boxes = [...group.querySelectorAll('input[type="checkbox"][data-action="fs-filter-change"]')];
                  const norm = s => String(s || '').trim().toLowerCase();

                  const target =
                    boxes.find(cb => cb.value === quickLinkFilter) ||
                    boxes.find(cb => cb.value === filterValue) ||
                    boxes.find(cb => norm(cb.value) === norm(quickLinkFilter)) ||
                    boxes.find(cb => norm(cb.value) === norm(filterValue));

                  if (target) boxes.forEach(cb => (cb.checked = cb === target));
                }

                const productsWrap = this.querySelector('[data-products-wrap]');
                if (productsWrap) {
                  const top = productsWrap.getBoundingClientRect().top + window.scrollY;
                  window.scrollTo({ top: top - 150, behavior: 'smooth' });
                }

                this.page = 1;
                this.narrowBy = this.buildNarrowBy();
                this.syncUrl(searchParams);
                this.loadPage(true);
                break;
              }

              this.syncGenderFromInput(clickedElement);
              this.page = 1;
              this.narrowBy = this.buildNarrowBy();
              this.syncUrl(searchParams);
              this.loadPage(true);
              break;
            }

            case 'remove-fs-filter': {
              const facetKey = actionElement.dataset.removeKey;
              const facetValue = actionElement.dataset.removeValue;

              if (facetKey === this.genderFacetKey) {
                this.setGender('', { skipUrlUpdate: true });
              } else {
                const inputElement = facetKey
                  ? this.querySelector(
                      `input[name="${CSS.escape(facetKey)}"][value="${CSS.escape(facetValue)}"]`
                    )
                  : this.querySelector(`input[value="${CSS.escape(facetValue)}"]`);

                if (inputElement) inputElement.checked = false;
              }

              this.page = 1;
              this.narrowBy = this.buildNarrowBy();
              this.syncUrl(new URLSearchParams(window.location.search));
              this.loadPage(true);
              break;
            }

            case 'remove-all-fs-filter':
              window.location = window.location.pathname;
              break;

            case 'fs-sort':
              this.sortBy = this.sortMap[actionElement.value] || 'relevency';
              this.page = 1;
              searchParams.set('sortBy', this.sortBy);
              history.replaceState({}, '', `?${searchParams}`);
              this.loadPage(true);
              break;

            case 'fs-pagination-next':
              this.page++;
              this.loadPage(false);
              break;

            case 'open-fs-filter-drawer':
              this.querySelector('[data-filter-container]')?.classList.add('open');
              document.body.classList.add('overflow-hidden');
              break;

            case 'close-fs-filter-drawer':
              this.querySelector('[data-filter-container]')?.classList.remove('open');
              document.body.classList.remove('overflow-hidden');
              break;
          }
        });
      });

      this.addEventListener('click', (e) => {
        const anchor = e.target.closest('[data-product-url][data-product-id][href]');
        if (!anchor) return;

        e.preventDefault();
        const index = [...this.querySelectorAll('[data-product-url][data-product-id][href]')]
          .findIndex(({ href }) => href === anchor.href);

        this.trackProductClick(anchor, index);
        window.location.href = anchor.href;
      });
    }

    buildNarrowBy() {
      const narrowByArray = [];
      const facetKey = this.genderFacetKey;

      const selectedGender =
        this.querySelector(`input[type="radio"][name="${facetKey}"]:checked`)?.value || '';
      if (selectedGender) narrowByArray.push([facetKey, selectedGender]);

      this.querySelectorAll('input:checked').forEach(inputElement => {
        if (!inputElement.name) return;
        if (inputElement.name === facetKey) return;
        if (inputElement.type === 'radio') return;
        narrowByArray.push([inputElement.name, inputElement.value]);
      });

      return narrowByArray;
    }

    syncUrl(existingParams) {
      const shouldKeepParam = key =>
        key === 'q' || key === 'sortBy' || key.startsWith('utm_') || key === 'gclid';

      const nextParams = new URLSearchParams();

      for (const [key, value] of existingParams.entries()) {
        if (shouldKeepParam(key)) nextParams.append(key, value);
      }

      this.narrowBy.forEach(([facetKey, facetValue]) => {
        nextParams.append(facetKey, facetValue);
      });

      history.replaceState({}, '', `?${nextParams}`);
    }

    syncFromUrl() {
      const searchParams = new URLSearchParams(window.location.search);

      const sortParam = searchParams.get('sortBy');
      if (sortParam) this.sortBy = sortParam;

      this.syncSortDropdown();

      this.narrowBy = [];

      for (const paramKey of new Set([...searchParams.keys()])) {
        if (
          paramKey === 'q' ||
          paramKey === 'sortBy' ||
          paramKey.startsWith('utm_') ||
          paramKey === 'gclid' ||
          paramKey === 'page'
        ) {
          continue;
        }

        searchParams.getAll(paramKey).forEach(paramValue => {
          this.narrowBy.push([paramKey, paramValue]);
        });
      }

      const genderValues = searchParams.getAll(this.genderFacetKey);
      const activeGender = genderValues.length ? genderValues[genderValues.length - 1] : '';

      this.setGender(activeGender, { skipUrlUpdate: true });

      this.narrowBy.forEach(([facetKey, facetValue]) => {
        if (facetKey === this.genderFacetKey) return;

        const inputElement = this.querySelector(
          `input[name="${CSS.escape(facetKey)}"][value="${CSS.escape(facetValue)}"]`
        );
        if (inputElement) inputElement.checked = true;
      });
    }

    trackSearchPerformed({ term, payload }) {
      window.FastSimonSDK?.event?.({
        eventName: window.FastSimonEventName.SearchPerformed,
        data: {
          query: term,
          narrowBy: this.narrowBy,
          sortBy: this.sortBy,
          products: (payload?.products || []).map(({ id }) => id).toString(),
          rescount: payload?.totalResults || 0,
          pagenum: Math.ceil((payload?.totalResults || 0) / this.productsPerPage)
        }
      });
    }

    trackSmartCollectionPerformed({ payload }) {
      window.FastSimonSDK?.event?.({
        eventName: window.FastSimonEventName.SmartCollectionPreformed,
        data: {
          categoryID: this.dataset.collectionId || this.dataset.id,
          narrowBy: this.narrowBy,
          sortBy: this.sortBy,
          products: (payload?.products || []).map(({ id }) => id).toString(),
          rescount: payload?.totalResults || 0,
          pagenum: Math.ceil((payload?.totalResults || 0) / this.productsPerPage),
        }
      });
    }

    loadPage(replace = true) {
      const loadMoreContainer = this.querySelector('.load-more-wrap');
      const productsWrap = this.querySelector('[data-products-wrap]');

      if (!productsWrap) return;

      const promoTileTemplates = Array.from(
        document.querySelectorAll('template[data-promo-tile]')
      );

      const promoTemplateByGridPosition = new Map();
      promoTileTemplates.forEach((templateEl) => {
        const gridPosition = Number(templateEl.dataset.promoTile);
        if (!Number.isFinite(gridPosition) || gridPosition <= 0) return;

        // If multiple templates share the same position, the last one in DOM order wins.
        promoTemplateByGridPosition.set(gridPosition, templateEl);
      });

      const shouldResetInsertedPromos = replace || !this.insertedPromoPositions;
      if (shouldResetInsertedPromos) {
        this.insertedPromoPositions = new Set();
      }

      const insertPromoTileAtPosition = (gridPosition) => {
        const templateEl = promoTemplateByGridPosition.get(gridPosition);
        if (!templateEl) return;

        const alreadyInsertedAtThisPosition = this.insertedPromoPositions.has(gridPosition);
        if (alreadyInsertedAtThisPosition) return;

        productsWrap.insertAdjacentHTML('beforeend', templateEl.innerHTML);
        this.insertedPromoPositions.add(gridPosition);
      };

      if (replace) {
        this.renderGridSkeleton();
        if (loadMoreContainer) loadMoreContainer.style.visibility = 'hidden';
      }

      const callback = (response) => {
        const payload = response.payload;

        if (replace) {
          productsWrap.innerHTML = '';
          this.insertedPromoPositions = new Set();
        }

        const products = payload?.products || [];
        const productsPerPageFromConfig = this.productsPerPage;
        const productsPerPageForIndexing = productsPerPageFromConfig || products.length || 0;

        for (let pageIndex = 0; pageIndex < products.length; pageIndex++) {
          const product = products[pageIndex];

          const productIndexAcrossAllPages =
            ((this.page - 1) * productsPerPageForIndexing) + pageIndex + 1;

          insertPromoTileAtPosition(productIndexAcrossAllPages);

          productsWrap.insertAdjacentHTML(
            'beforeend',
            `<intersection-loader data-url="${product.u}" data-section-id="product-tile"></intersection-loader>`
          );
        }

        if (loadMoreContainer) loadMoreContainer.style.visibility = '';

        const normalizedFacets = this.normalizeFacets(payload?.facets);
        const hasFacets = Object.keys(normalizedFacets).length > 0;
        const filtersWrap = this.querySelector('[data-filters-wrap]');

        if (hasFacets) {
          this.renderFilters(normalizedFacets);
          this.syncFromUrl();

          const shouldAttemptRestore = !this._restored;
          if (shouldAttemptRestore) {
            this._restored = true;

            const restoredNarrowBy = this.buildNarrowBy();
            const hasRestoredNarrowBy = restoredNarrowBy.length > 0;

            if (hasRestoredNarrowBy) {
              this.narrowBy = restoredNarrowBy;
              this.page = 1;
              this.loadPage(true);
              return;
            }
          }

          filtersWrap?.classList.remove('!hidden');
        } else {
          filtersWrap?.classList.add('!hidden');
        }

        this.renderRemoveButtons();

        const isLastPage = payload.pageCount <= this.page;
        if (isLastPage) this.classList.add('fully-loaded');
        else this.classList.remove('fully-loaded');

        const loadedCountEl = this.querySelector('[data-products-loaded]');
        if (loadedCountEl) {
          const loadedCount = replace
            ? Math.min(products.length, payload.totalResults)
            : Math.min(this.page * productsPerPageForIndexing, payload.totalResults);

          loadedCountEl.innerText = loadedCount;

          const loadMoreWrapper = this.querySelector('[data-load-more-wrapper]');
          if (loadMoreWrapper) loadMoreWrapper.style.display = loadedCount === 0 ? 'none' : '';
        }

        this.querySelectorAll('[data-total-products]').forEach((el) => {
          el.innerText = payload.totalResults;
        });

        if (this.dataset.id === 'search') {
          this.trackSearchPerformed({ term: this.query, payload });
        } else {
          this.trackSmartCollectionPerformed({ payload });
        }
      };

      const requestOptions = {
        page: this.page,
        narrowBy: this.narrowBy,
        sortBy: this.sortBy,
        productsPerPage: this.productsPerPage,
        callback
      };

      if (this.dataset.id === 'search') {
        window.FastSimonSDK.fullTextSearch({ term: this.query, ...requestOptions });
      } else {
        window.FastSimonSDK.smartCollections({
          categoryID: this.dataset.collectionId,
          ...requestOptions
        });
      }
    }

    normalizeFacets(facets) {
      if (!Array.isArray(facets)) return {};

      const out = {};
      facets.forEach(([facetKey, facetValues]) => {
        if (!Array.isArray(facetValues)) return;

        out[facetKey] = {};
        facetValues.forEach(([value, count]) => {
          out[facetKey][value] = count;
        });
      });

      return out;
    }

    renderFilters(facets) {
      if (!facets) return;

      const wraps = this.querySelectorAll('[data-filters-wrap]');
      if (!wraps.length) return;

      const normalizeName = facetKey => {
        if (facetKey === 'Size') return 'size';
        if (facetKey === 'Width') return 'width';

        if (facetKey.startsWith('Isp-tag-')) {
          return facetKey
            .replace('Isp-tag-', '')
            .toLowerCase()
            .replace('category', 'type')
            .replace('color', 'color-family');
        }

        return facetKey.toLowerCase();
      };

      wraps.forEach(wrap => {
        wrap.innerHTML = `
          <div class="hidden lg:block font-medium tracking-[0.96px]">${this.dataset.filterLabel}</div>
          <content-accordion class="flex items-center gap-6">
            <ul class="max-lg:w-full max-lg:[&_li]:py-5 ">
              ${Object.entries(facets)
                .map(([facetKey, valueObj]) => {
                  const filterName = normalizeName(facetKey);
                  const values = Object.keys(valueObj);
                  if (!values.length) return '';
                  return this.renderFilterList(filterName, values, facetKey);
                })
                .join('')}
            </ul>
          </content-accordion>
        `;
      });
    }

    renderFilterList(name, values, facetKey) {
      let label;

      if (name.includes('color-family')) label = 'color';
      else if (name.includes('type')) label = 'category';
      else label = name.replaceAll('_', ' ').replaceAll('-', ' ');

      if (this.translationValues?.hasOwnProperty(label)) {
        label = this.translationValues[label];
      }

      const isGenderCollection =
        this.dataset.collectionHandle?.includes('men') ||
        this.dataset.collectionHandle?.includes('women');

      return window.renderAccordionItem({
        carat: true,
        isOpenByDefault: false,
        isHidden: name === 'gender' && isGenderCollection,
        label,
        id: facetKey,
        content: `
          <ul
            data-fs-filter-group="${facetKey}"
            data-filter-name="${name}"
            class="filter-list filter-list-${name.replace('taille', 'size').replace('größe', 'size')}"
          >
            ${values
              .sort((a, b) => {
                const isNum = v => !isNaN(parseFloat(v));
                const allNum = values.every(isNum);
                if (allNum) return parseFloat(a) - parseFloat(b);
                return a.localeCompare(b);
              })
              .map((value, index) => `
                <li class="filter-list-item ${value}">
                  ${this.renderCheckbox({
                    label: value.replaceAll('_', ' '),
                    value,
                    id: `filter-value-${value}-${index}`,
                    facetKey,
                    swatch: name.includes('color'),
                    price: name.toLowerCase().includes('price')
                  })}
                </li>
              `)
              .join('')}
          </ul>
        `
      });
    }

    renderCheckbox({ label, value, id, facetKey, swatch, price }) {
      const searchParams = new URLSearchParams(window.location.search);
      const checked = searchParams.getAll(facetKey).includes(value);

      if (this.translationValues?.hasOwnProperty(label)) {
        label = this.translationValues[label];
      }

      const display = price
        ? `$${label.replaceAll(':', ' - $')}`
        : `${label}`;

      return `
        <input
          title="${label}"
          ${checked ? 'checked' : ''}
          id="${id}"
          name="${facetKey}"
          type="checkbox"
          value="${value}"
          data-action="fs-filter-change"
        >
        <label for="${id}">
          ${swatch ? `
            <span
              style="
                background-size: contain;
                background-color: ${label};
                background-image: url('https://www.orthofeet.com/cdn/shop/files/swatch-filter-${encodeURI(
                  label.toLowerCase().replaceAll(' ', '-')
                )}_small.png');
              "
              class="swatch"
            ></span>
          ` : ''}
          ${display}
        </label>
      `;
    }

    renderRemoveButtons() {
      const wrap = this.querySelector('[data-remove-filters-mobile]');
      if (!wrap) return;

      const genderValue =
        this.querySelector(`input[type="radio"][name="${this.genderFacetKey}"]:checked`)?.value || '';

      wrap.innerHTML = '';

      const pills = [];

      if (genderValue) {
        pills.push({
          key: this.genderFacetKey,
          value: genderValue,
          label: 'Gender',
          valueLabel: genderValue
        });
      }

      const otherCheckedInputs = [...this.querySelectorAll('input:checked')].filter(input => {
        if (!input.name) return false;
        if (input.name === this.genderFacetKey) return false;
        if (input.type === 'radio') return false;
        return true;
      });

      const facetLabel = facetKey => {
        let cleaned = facetKey || '';
        if (cleaned.startsWith('Isp-tag-')) cleaned = cleaned.replace('Isp-tag-', '');
        if (cleaned.startsWith('named_tags.')) cleaned = cleaned.replace('named_tags.', '');
        if (cleaned.startsWith('options.')) cleaned = cleaned.replace('options.', '');

        const lower = cleaned.toLowerCase();
        if (lower === 'color-family') return 'Color';
        if (lower === 'type') return 'Category';

        return cleaned.replaceAll('_', ' ').replaceAll('-', ' ');
      };

      const valueLabel = input => input.getAttribute('title') || input.value || '';

      otherCheckedInputs.forEach(input => {
        pills.push({
          key: input.name,
          value: input.value,
          label: facetLabel(input.name),
          valueLabel: valueLabel(input)
        });
      });

      if (!pills.length) return;

      wrap.insertAdjacentHTML(
        'beforeend',
        `<button data-action="remove-all-fs-filter" class="remove-filter-button remove-all-filter-button">
          Clear All
        </button>`
      );

      pills.forEach(pill => {
        wrap.insertAdjacentHTML(
          'beforeend',
          `<button
            data-action="remove-fs-filter"
            data-remove-key="${pill.key}"
            data-remove-value="${pill.value}"
            class="remove-filter-button text-secondaryDark border-2 border-orthoCream"
          >
            ${pill.label}: <span class="text-primaryDark">${pill.valueLabel}</span>
          </button>`
        );
      });
    }

    renderGridSkeleton() {
      const productsWrap = this.querySelector('[data-products-wrap]');
      if (!productsWrap) return;

      const loaderMarkup = `
        <div class="loader">
          <span class="block w-12 h-12">
            <svg class="animate-spin -ml-1 mr-3 h-full w-full text-primaryBrand" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </span>
        </div>
      `;

      productsWrap.innerHTML = Array.from({ length: 8 })
        .map(() => `
          <div class="flex flex-col justify-start bg-secondaryLight mix-blend-multiply rounded-lg overflow-hidden opacity-50">
            <div class="aspect-[78/100] relative flex items-center justify-center loading w-full bg-secondaryLight mix-blend-multiply min-h-[290px]">
              ${loaderMarkup}
            </div>
          </div>
        `).join('');
    }
  }

  customElements.define('product-listing', ProductListing);
}